export const ThemeList = {
  GANGA: "GANGA",
};

export const themes = {
  GANGA: {
    primary: "#18355F",
    secondary: "#EB881A",
  },
  DEFAULT: {
    primary: "#18355F",
    secondary: "#EB881A",
  },
};

export const getTheme = (themeName) => {
  return themeName ? themes[themeName] : themes.DEFAULT;
};
